import { getHiddenDataBoolean, getHiddenDataString } from '../hidden-data-provider';
import { ICartData } from '../../projects/shopping-cart/cart/interfaces';
import { get } from '../../DAL/data-provider';

/**
 * send facebook 'add to cart' event
 */
export const facebookAddToCart = (cartData: ICartData) => {

    if(!window.fbq ||
        !cartData.addedProductSKUID ||
        !cartData.facebookAddToCartGuid ||
        !cartData.cartItems) return;

    const cartItem = cartData.cartItems.find((item => item.skuid === cartData.addedProductSKUID));
    if(!cartItem) return;

    window.fbq('track', 'AddToCart', {
        content_ids: [cartItem.skuNumber],
        content_type: 'product',
        value: cartItem.skuPrice,
        currency: 'USD'
    }, {
        eventID: cartData.facebookAddToCartGuid,
    });
};

/**
 * lead
 */
export const facebookLead = () => {
    if(!window.fbq) return;
    window.fbq('track', 'Lead');
};

export const facebookProductPagesViewContent = () => {
    if(!window.ttq) return;

    const jsonString = getHiddenDataString('efs-data');
    let json = null;

    try{
        json = JSON.parse(jsonString);
    }
    catch(ex){}

    if(!json || !Array.isArray(json) || json.length <= 0) return;

    const product = json[0];
    if(product.skuNumber && product.skuPrice > 0){

        window.fbq('track', 'ViewContent', {
            content_type: 'product',
            content_ids: [product.skuNumber],
            value: product.skuPrice,
            currency: 'USD'
        }, {eventID: getHiddenDataString('fb-viewcontent')});
    }
};

export const sendFacebookPageViewEvent = async () => {
    const enabled = getHiddenDataBoolean('fb-events-enabled');
    if(!enabled) return;

    const guid = getHiddenDataString('fb-page-view');
    if(!guid) return;

    return await get('/api/facebook/send-page-view-event', {
        guid
    });
};

/**
 * https://developers.facebook.com/docs/javascript/quickstart
 */
export const initFacebookApi = () => {
    window.fbAsyncInit = () => {

        if(!window.FB) return;

        window.FB.init({
            appId      : '229024110469201', //'229024110469201',
            cookie     : true,
            xfbml      : true,
            version    : 'v2.9'
        });

        window.FB.AppEvents.logPageView();
    };

    (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        // @ts-ignore
        js.src = "//connect.facebook.net/en_US/sdk.js";
        // @ts-ignore
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
};

export const facebookShare = async (shareURL: string): Promise<void> => {
    return new Promise((resolve, reject) => {
        if(!window.FB){
            reject();
            return;
        }

        window.FB.ui({
                // @ts-ignore
                method: 'share',
                href: shareURL,
                scrape: true
            },
            (_response: any) => {
                resolve();
            }
        );
    });
};
